import Holidays from 'date-holidays';
import moment from 'moment';
import 'moment-timezone';

const isHoliday = (date: Date | string) => {
  const holiday = new Holidays();
  holiday.init('US');
  return holiday.isHoliday(date);
};

export const checkIfAnyHoliday = (dates: (Date | string)[]) =>
  Object.values(dates).some((date) => isHoliday(date));

/**
 * Converts an array of date strings to local time strings in a specified timezone.
 * @param {string[]} dateStrings - Array of date strings in 'YYYY-MM-DD' format.
 * @param {string} timeZone - Timezone identifier (e.g., 'America/New_York').
 * @returns {string[]} Array of local time strings formatted according to the timezone.
 */
export const convertDatesToTimezone = (dateStrings: string[], timeZone: string) =>
  dateStrings.map((dateString) => {
    const date = moment.tz(
      `${dateString} ${moment().format('HH:mm:ss')}`,
      'YYYY-MM-DD HH:mm:ss',
      timeZone,
    );

    return date.format('YYYY-MM-DD h:mm A');
  });

  